/** English — source of truth for all translation keys */
const locale = {
  appName: 'Kiness',
  tagline: 'Keeping Families Connected',
  signIn: 'Sign In',
  signUp: 'Sign Up',
  signOut: 'Sign Out',
  email: 'Email',
  password: 'Password',
  name: 'Full name',
  facilityCode: 'Facility code',
  facilityCodeHint: 'Ask your care home for this code',
  noAccount: "Don't have an account?",
  haveAccount: 'Already have an account?',
  signingIn: 'Signing in…',
  creatingAccount: 'Creating account…',
  loginError: 'Could not sign in — check your email and password',
  registerError: 'Could not create account — please try again',
  welcomeBack: 'Welcome back',
  welcomeNew: 'Join your care community',
  selectResident: 'Who is this update for?',
  updatePlaceholder: 'How is {name} doing today?',
  addPhoto: 'Add photo',
  postUpdate: 'Post Update',
  posting: 'Posting…',
  postSuccess: 'Update posted — family will be notified',
  postError: "Couldn't post update — check your connection and try again",
  yourLovedOne: 'Your loved one',
  familyFeed: 'Family feed',
  tabFeed: 'Feed',
  tabRecord: 'Record',
  tabCalendar: 'Calendar',
  tabPhotos: 'Photos',
  noUpdates: 'No updates yet — check back soon',
  pullRefresh: 'Pull down to refresh',
  refreshing: 'Refreshing…',
  admin: 'Admin',
  dashboard: 'Dashboard',
  residents: 'Residents',
  familyLinks: 'Family linking',
  staff: 'Staff',
  facility: 'Facility',
  residentsCount: 'Residents',
  familyLinked: 'Family members linked',
  updatesToday: 'Updates posted today',
  addResident: 'Add resident',
  editResident: 'Edit',
  removeResident: 'Remove',
  firstName: 'First name',
  lastName: 'Last name',
  room: 'Room',
  save: 'Save',
  cancel: 'Cancel',
  addFamilyEmail: 'Add family by email',
  addStaffEmail: 'Add staff by email',
  staffAdd: 'Add',
  staffCount: '{count} on staff',
  relationship: 'Relationship',
  inviteSent: 'Invite ready — they can register with your facility code',
  loading: 'Loading…',
  installTitle: 'Add Kiness to your home screen',
  installBody: 'Get quick access to updates about your loved one',
  installButton: 'Add to Home Screen',
  installDismiss: 'Not now',
  installIosSteps:
    'In Safari, tap Share (the square with an arrow) at the bottom of the screen, then tap "Add to Home Screen".',
  installAndroidManual:
    'Tap the menu (⋮) in Chrome, then choose "Install app" or "Add to Home screen".',
  installOpenSafari:
    'To install, open this page in Safari first — copy the link, paste it in Safari, then use Share → Add to Home Screen.',
  installGotIt: 'Got it',
  language: 'Language',
  chooseLanguage: 'Choose your language',
  chooseLanguageSub: '选择您的语言',
  changeLanguageHint: 'You can change this anytime via the globe icon',
  english: 'English',
  chinese: '中文',
  newUpdate: 'New update',
  from: 'from',
  roomLabel: 'Room',
  confirmRemove: 'Remove this resident?',
  staffPostTitle: 'Post an update',
  voiceHoldToTalk: 'Hold to talk',
  voiceRelease: 'Release to send',
  voiceProcessing: 'Processing your note…',
  voiceSelectFirst: 'Select a resident first',
  voiceHint: 'Hold the button, speak for a few seconds, then release. Max 10 seconds.',
  voiceReviewTitle: 'Review before sending',
  voiceReviewSubtitle: 'Edit if needed — nothing goes to {name}\'s family until you approve.',
  voiceTranscript: 'What you said',
  voiceCareNote: 'Staff record note',
  voiceFamilyUpdate: 'Family update',
  voiceApprove: 'Approve & send to family',
  voiceApproving: 'Sending…',
  voiceCancel: 'Cancel',
  voiceParseFailed: 'We could not auto-format this note — please edit both fields before sending.',
  voiceRateLimit: 'Voice service is busy — try again in a moment',
  typeInstead: 'Type instead',
  adminTitle: 'Facility dashboard',
  linkedFamily: 'Linked family',
  pendingInvite: 'Pending invite',
  noResidents: 'No residents yet — add your first resident',
  noStaff: 'No staff yet',
  photoOptional: 'Photo (optional)',
  dashboardSettingUp: 'Setting up your dashboard…',
  dashboardEmptyHint: 'Add your first resident to get started',
};

export default locale;
